<mat-toolbar color="primary">
  <button class="left-date-browser" mat-icon-button routerLink="../../skills" title="back">
    <mat-icon fontIcon="fa-chevron-left" fontSet="fas"></mat-icon>
  </button>
  {{ skill?.description }}
</mat-toolbar>
@if (!isLoading && !isError) {
<div class="container">
  @if (skill) {
  <app-resource-skill-mapping-for-skill [skill]="skill"></app-resource-skill-mapping-for-skill>
  }
</div>
}